/* RESPONSIBLE TEAM: team-actions */
import { attr } from '@ember-data/model';
import Fragment from 'ember-data-model-fragments/fragment';

export default class LogContext extends Fragment {
  @attr('array') declare attributeFilter: Array<string>;
  @attr('string') declare message: string;
}
